import { SvgIconBase } from '../utils/types';

export default function ReportDispute({
  width = '24',
  height = '24',
  className = 'fill-current',
}: SvgIconBase) {
  return (
    <svg
      width={width}
      height={height}
      className={className}
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="fi_726199">
        <g id="Group">
          <g id="Group_2">
            <path
              id="Vector"
              d="M13.75 0V5.5H19.25L13.75 0Z"
              fill="currentColor"
              fillOpacity="0.85"
            />
          </g>
        </g>
        <g id="Group_3">
          <g id="Group_4">
            <path
              id="Vector_2"
              d="M13.75 6.875C12.9924 6.875 12.375 6.25763 12.375 5.5V0H4.125C3.36738 0 2.75 0.617375 2.75 1.375V20.625C2.75 21.384 3.36738 22 4.125 22H17.875C18.634 22 19.25 21.384 19.25 20.625V6.875H13.75ZM8.25 19.25H5.5V15.125H8.25V19.25ZM12.375 19.25H9.625V12.375H12.375V19.25ZM16.5 19.25H13.75V9.625H16.5V19.25Z"
              fill="currentColor"
              fillOpacity="0.85"
            />
          </g>
        </g>
      </g>
    </svg>
  );
}
